// extracted by mini-css-extract-plugin
export default {"stat":"FirstAndLast_stat__ZT-Tm","item":"FirstAndLast_item__wgYc9"};